import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {
    simulationResultList: {},
  }
}

const state = getDefaultState()

const mutations = {
  SET_MENU_LISTS(state, payload) {
    state.simulationResultList = payload
  },
}

const actions = {
  async getChartData({ commit }, payload) {
    const res = await apiService.post(route('member.fcs.simulation-result.get_chart_data'), payload)
    if (res && res.data) {
      return res.data
    }
  },
  async getTableDataByForest({ commit }, payload) {
    const res = await apiService.post(route('member.fcs.simulation-result.get_table_data_by_forest'), payload)
    if (res && res.data) {
      return res.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
